import { create } from 'zustand';
import type { MinhaMesaTab } from '../types';

interface MinhaMesaState {
  selectedTaskId: string | null;
  activeTab: MinhaMesaTab;
  formState: Record<string, unknown>;
  checklistState: Record<string, boolean>;
  notes: string;
  isSaving: boolean;

  // Actions
  selectTask: (taskId: string | null) => void;
  setActiveTab: (tab: MinhaMesaTab) => void;
  setFormField: (fieldId: string, value: unknown) => void;
  setFormState: (state: Record<string, unknown>) => void;
  toggleChecklistItem: (itemId: string) => void;
  setChecklistState: (state: Record<string, boolean>) => void;
  setNotes: (notes: string) => void;
  setIsSaving: (saving: boolean) => void;
  resetTaskState: () => void;
}

export const useMinhaMesaStore = create<MinhaMesaState>((set) => ({
  selectedTaskId: null,
  activeTab: 'instrucoes',
  formState: {},
  checklistState: {},
  notes: '',
  isSaving: false,

  selectTask: (taskId) =>
    set({
      selectedTaskId: taskId,
      activeTab: 'instrucoes',
      formState: {},
      checklistState: {},
      notes: '',
    }),

  setActiveTab: (tab) => set({ activeTab: tab }),

  setFormField: (fieldId, value) =>
    set((state) => ({
      formState: { ...state.formState, [fieldId]: value },
    })),

  setFormState: (formState) => set({ formState }),

  toggleChecklistItem: (itemId) =>
    set((state) => ({
      checklistState: {
        ...state.checklistState,
        [itemId]: !state.checklistState[itemId],
      },
    })),

  setChecklistState: (checklistState) => set({ checklistState }),

  setNotes: (notes) => set({ notes }),

  setIsSaving: (isSaving) => set({ isSaving }),

  resetTaskState: () =>
    set({
      selectedTaskId: null,
      activeTab: 'instrucoes',
      formState: {},
      checklistState: {},
      notes: '',
      isSaving: false,
    }),
}));
